import React from "react";
import { NavLink } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../src/BaseUrl";
import { toast } from "react-toastify";

//3rd party packages
import moment from "moment";
import ReactPaginate from "react-paginate";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Cookies from "universal-cookie";
import { connectAndSendMessage } from 'retail-integration-package';
import { downloadLogs } from 'retail-integration-package';
import { ToastError, ToastSuccess } from "./ToastShow";

//importing ends
const cookies = new Cookies();

// functions starts here
//console functions, clear and dummy text like facebook
const consolee = () => {
  var cssStop = "color: Red; font-size: 50px; font-weight: bold;";
  var cssText = "color: Black; font-size: 18px; font-weight: bold;";
  console.clear();
  console.log("%cStop!", cssStop);
  console.log(
    "%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature or hack someone's account, it is a scam.",
    cssText
  );
};

// get offline orders
const handleGetOrders = async (localUrl) =>{
  try {
    const response = await axios.get(localUrl, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    return response.data; 
  } catch (error) {
    console.error("Error fetching orders:", error);
    return error.response?.data; 
  }
}

// net check api
const createNetworkChecker = () => {
  let lastResult = null;
  let lastCallTime = 0;
  let inFlightPromise = null;
  const CACHE_DURATION = 15000; // 15 seconds
  return async function checkNetworkStatus() {
    const now = Date.now();

    // If request already in progress → reuse it
    if (inFlightPromise) {
      return inFlightPromise;
    }

    // If last call within 7s → return cached result
    if (((now - lastCallTime) < CACHE_DURATION) && lastResult !== null) {
      return lastResult;
    }

    // Otherwise → make fresh request
    const url = BASE_URL + "/check-net";
    inFlightPromise = axios.get(url, { timeout: 5000 })
      .then((response) => {
        lastResult = response?.data && parseInt(response.data) === 1;
        lastCallTime = Date.now();
        inFlightPromise = null;
        return lastResult;
      })
      .catch(() => {
        lastResult = false;
        lastCallTime = Date.now();
        inFlightPromise = null;
        return false;
      });
    return inFlightPromise;
  };
};

const checkNetworkStatus = createNetworkChecker();

// const checkNetworkStatus = async () => {
//   try {
//     const url = BASE_URL + "/check-net";
//     const response = await axios.get(url,{
//       timeout: 3000, 
//     });
//     if(response?.data){
//       return parseInt(response.data) === 1
//     }else{
//       return false
//     }
//   } catch (error) {
//     return false;
//   }
// }

//toast options
export const toastObj = {
  position: "bottom-center",
  autoClose: 7000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  className: "text-center toast-notification",
};

const handleDownloadLogs = () => {
  try {
    downloadLogs();
  } catch (err) {
    console.error('Failed to download logs:', err);
  }
};

const processCardPayment = async (type, amount, invoice) => {
  try {
    console.log("loop pay payload", type, invoice);
    const result = await connectAndSendMessage(type, amount, invoice);
    console.log("loop pay success", result);
    if (result.error) {
      if(result.response === "DECLINED"){
        toast.error(result.error,toastObj);
      }else{
        toast.error("Transaction Failed",toastObj);
      }
      console.error("loop pay error", result.error);
    } else {
      if(result?.response === "APPROVED"){
        toast.success("Transaction successful",toastObj)
      }else{
        toast.error("Payment Declined",toastObj); 
      }
    }
    return result
  } catch (err) {
    console.error('Timeout or connection error:', err);
    toast.error("Transaction Timeout or connection error",toastObj);
    return { success: false, error: err }
  } finally {
    // always executed
    handleDownloadLogs();
  }
}

const handleCardTransaction = async (token, branch, amount, invoiceInput= "") => {
  const isVoid = (invoiceInput === "Void") || (invoiceInput === "VOID");
  const type = isVoid ? "VOID" : "SALE"
  const res = await processCardPayment(type, amount, invoiceInput);

  const formData = {
    token: token,
    branch_id: branch?.id,
    amount: amount,
    integration_type: branch?.payment_integration,
    payment: res.success ? res.data : res.error,
  }
  try{
    const url = BASE_URL + "/settings/new-payment-integration";
    const result = await axios.post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });

    if(result.data){
      return res
    }else{
      return res
    }
  }catch (err){
    console.log(err)
    return res
  }
}

export const handleKeenuTransaction = async(token, branch, amount, unique_token=null, invoiceInput= "") => {
  const isVoid = (invoiceInput === "Void") || (invoiceInput === "VOID");
  const txnType = isVoid ? "Void" : "Sales";
  const formattedAmount = parseFloat(amount || 0).toFixed(2);
  const keenuIngration = branch?.keenu_integration;

  const hmac= await generateSHA256(unique_token, "@#KEENU@#PAYMENT@##$", branch?.id)

  let branchId = keenuIngration?.[0]?.keenu_id;
  let tillId = keenuIngration?.[0]?.till_id;
  // let keenuUsername = keenuIngration?.[0]?.username;
  // let keenuPassword = keenuIngration?.[0]?.password;

  // Validate branchId and tillId are assigned and configured
  // if (!branchId || !tillId) {
  //   let missingFields = [];
  //   if (!branchId) missingFields.push("Branch ID (Keenu ID)");
  //   if (!tillId) missingFields.push("Till ID");
  //   const errorMsg = `Keenu ${missingFields.join(" & ")} is not assigned or configured for this branch. Please configure Keenu terminal settings in Branch Details.`;

  //   toast.error(`Keenu: ${errorMsg}`, toastObj);
  //   return {
  //     success: false,
  //     response: "FAILED",
  //     error: errorMsg,
  //     data: null,
  //   };
  // }

  const formData = {
    txnType: txnType,
    amount: formattedAmount,
    // TenderId: "Keenu",
    // BranchId: branchId,
    // TillId: tillId,
    deviceId: String(branch?.id || ""),
    branchId: branch?.id ?? "",
    encryption: true,
    invoiceNo: String(unique_token ?? token),
  };

  try{
    const url = BASE_URL + "/v1/integrations/keenu/payment-request";
    // const username = keenuUsername || "wirelessretailapi";
    // const password = keenuPassword || "2Ba9OYpzBWzxtPudQhsM6A==";
    console.log("Keenu Request Payload:", formData);

    const result = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${getCookie()}`,
        ...(hmac ? { 'X-HMAC': hmac } : {})
      },
    });

    console.log("Keenu API Raw Response:", result?.data);

    let resData = result?.data;
    if (typeof resData === "string") {
      try {
        resData = JSON.parse(resData);
      } catch (e) {
        // preserve string
      }
    }
    console.log("abcd6", resData);

    // Success: Approved by terminal
    const isApproved =
      ((resData?.status === "success" || resData?.status_code === 200) &&
        (resData?.data?.RESPONSE === "APPROVED" ||
          resData?.message === "APPROVED"));

    if (isApproved) {
      toast.success("Keenu Transaction Approved", toastObj);
      return {
        success: true,
        response: "APPROVED",
        data: resData?.data || resData?.response || resData,
        error: null,
      };
    }

    // Failures: Declined, Timeout, or Validation Error
    const isDeclined =
      resData?.data?.RESPONSE === "DECLINED" ||
      resData?.message === "DECLINED" ||
      resData?.response?.response === "DECLINED" ||
      resData?.status === "declined";

    const errorMsg = isDeclined
      ? "Payment Declined by Terminal"
      : resData?.error?.message ||
        (resData?.message && resData?.message !== "APPROVED" ? resData?.message : null) ||
        (typeof resData === "string" ? resData : "Keenu Payment Failed");

    toast.error(`Keenu: ${errorMsg}`, toastObj);
    return {
      success: false,
      response: isDeclined ? "DECLINED" : "FAILED",
      error: errorMsg,
      data: resData?.data || resData?.response || resData?.error || resData,
    };
  }catch (err){
    console.error("Keenu API Error:", err);
    const errorMsg =
      err?.response?.data?.error?.message ||
      err?.response?.data?.message ||
      (typeof err?.response?.data === "string" ? err?.response?.data : null) ||
      err?.message ||
      "Transaction Timeout or connection error";

    toast.error(`Keenu: ${errorMsg}`, toastObj);
    return {
      success: false,
      response: "FAILED",
      error: errorMsg,
      data: err?.response?.data || null,
    };
  }
}

const paymentIntegrations = {
  "loop_pay": handleCardTransaction,
  "keenu": handleKeenuTransaction,
  // Add future integrations here
};

export const processPaymentIntegrations = async (integrationType, paymentTypes, tokenId, unique_token, branchInfo) => {
  let paymentResponse = "";

  const paymentHandler = paymentIntegrations[integrationType];

  if (paymentHandler) {
    if (paymentTypes && paymentTypes.length) {
      for (const item of paymentTypes) {
        if (item.card_payment) {
          const res = await paymentHandler(
            tokenId,
            branchInfo,
            item.bill_amount.toFixed(2),
            unique_token,
          );
          paymentResponse = {
            response: res,
            payment_type_id: item.id ?? item.payment_type_id,
          };
          if (res?.response !== "APPROVED" || res?.error) {
            break;
          }
        }
      }
    }
  }

  return paymentResponse;
};

//select style
const customStyle = {

  control: (provided) => ({
    ...provided,
    minHeight: "2rem",
    marginTop: "0",
    marginBottom: "0",
  }),
  singleValue: (provided) => ({
    ...provided,
    alignSelf: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: '7rem',
    overflowY: 'auto',
    flexWrap: 'wrap',
    marginTop: "0",
    padding: "0 0.5rem",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 0.4rem",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    margin: "0.4rem 0",// or any other custom styling
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.88rem",
    zIndex: 1099, // Ensure the menu is above other elements
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 1099,
  }),
  clearIndicator:(provided) => ({
    ...provided,
    padding: "0 0.4rem",// or any other custom styling
  }),  

};

//translation functions
let _t = (text) => {
  // let localLang = localStorage.getItem("i18nextLng");
  // if (localLang.includes("en")) {
  //   const url = BASE_URL + `/settings/save-to-en`;
  //   let formData = {
  //     key: text,
  //   };
  //   axios.post(url, formData);
  // }
  return text;
};

//Get cookie of authentication
const getCookie = () => {
  if (cookies.get("_user") !== undefined) {
    let token =
      cookies.get("_user") +
      cookies.get("sbb") +
      cookies.get("frr") +
      cookies.get("xss");
    return token;
  }
};

const getFirebaseCookie = () => {
  if (cookies.get("_fb-user") !== undefined) {
    let token = cookies.get("_fb-user") + cookies.get("fb");
    return token;
  }
};

//get table res time
const getReseredTime = (time) =>{
  let date = new Date().getTime();
  let Time = new Date(time).getTime()
  let actualTime = date - Time;
  let min = (Math.floor(actualTime / 60000) % 60);;
  let hour = (Math.floor(actualTime / 3600000) % 24);
  if(hour  > 0){
    return `${hour} hr: ${min} min` 
  }else{
    return `${min} mins` 
  }
}

const getVoucherUsage = async (card_no, vocuher, type) => {
  try {
    const url = BASE_URL + "/settings/check-offer-card-no";
    const formData = {
      card_no: card_no,
      type: type,
      id:vocuher
    }
    
    const response = await axios.post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    return response.data;
  } catch (error) {
    if(error?.response?.data){
      return error.response.data
    }
    console.log("voucher check",error)
  }
}

// get api time
const getApiTime = (key) => {
  const apiTime = sessionStorage.getItem(key);
  return apiTime ? new Date(JSON.parse(apiTime)) : null;
}

// set api time
const setApiTime = (key, time = 45) => {
  const futureTime = new Date();
  futureTime.setMinutes(futureTime.getMinutes() + (time ?? 45));
  sessionStorage.setItem(key, JSON.stringify(futureTime));
}

// Compare current time with API time
const isTimeExpired = (key) => {
  const targetTime = getApiTime(key);
  const currentTime = new Date();

  return !targetTime || (currentTime > targetTime);
};

// queue tracker
// let currentQueue = Promise.resolve();

//get firebase auth token
const getFirebaseToken = async(endPoint)=>{
  if(endPoint && getCookie()){
    if(getFirebaseCookie()){
      return getFirebaseCookie()
    }else{
      try {
        const url = BASE_URL + `/settings/fb_token/${endPoint}`;
        const res = await axios.get(url,{
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res.data){
          const access_firbase = {
            _user: res.data.slice(0, 10),
            fb: res.data.slice(10),
          };
          const dateHour = new Date();
          dateHour.setMinutes(dateHour.getMinutes() + 45);
          
          cookies.set("_fb-user", access_firbase._user, {
            path: "/",
            expires: dateHour,
            sameSite: "lax",
            secure: true,
          });
          cookies.set("fb", access_firbase.fb, {
            path: "/",
            expires: dateHour,
            sameSite: "lax",
            secure: true,
          });
          return res.data;     
        }
      } catch (error) {
        console.log("firebase auth",error);
      };
    }
    // currentQueue = currentQueue.then(async () => {
    // });
    // return currentQueue
  }
}

//sync offline order to server
const offlineOrderSync = async(order) =>{
  const url = BASE_URL + "/settings/sync-offline-orders-to-server";
  const formData = {
    ...order
  };
  try{
    let result = await axios.post(url,formData,{
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    if(result?.data){
      return result.data;
    }else{
      return false
    }
  }catch(err){
    if(err.response.data?.status === 2){
      // toast.error(err.response.data.message, toastObj);
      return err.response.data?.order_id
    }
    return false
  }    
}


const maxLoyaltyPoint = (total) =>{
  if(total > 0){
    const points = JSON.parse(localStorage.getItem("loyalty"));
    if(points?.maxOrderDiscount && points?.maxOrderDiscountPercentage){
      const percent = (points?.maxOrderDiscountPercentage / 100) * total;
      if(percent > points?.maxOrderDiscount){
        return points?.maxOrderDiscount
      }
      return Number(percent.toFixed(2))
    }else if(points?.maxOrderDiscount){
      return points?.maxOrderDiscount
    }else if(points?.maxOrderDiscountPercentage){
      const percent = (points?.maxOrderDiscountPercentage / 100) * total;
      return Number(percent.toFixed(2))
    }
  }
  return "";
}

//set loyality points 
const getLoyaltyPoint = async() => {
  try{
    const url = BASE_URL + "/settings/merchat-loyaltySys-configuration";
    const res = await axios.get(url,{
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    if(res.data){
      const loyalty = {
        maxOrderDiscount: res.data.details.maxOrderDiscount,
        maxOrderDiscountPercentage: res.data.details.maxOrderDiscountPercentage,
      }
      localStorage.setItem("loyalty",JSON.stringify(loyalty));
      return loyalty;
    }
  }catch(err){
    console.log("error fetching loyalty points")
  }
}

//get customer points
const getCustomerRegInfo = async(params, setLoading="") => {
  const formData = {
    customer_no: params.phn_no,
    branch_code: params.branch?.code || "",
    ...(params?.dob && {dob: params.dob}),
    ...(params?.gender && {gender: params.gender}),
    ...(params?.address && {cust_address: params.address}),
    ...(params?.name && {first_name: params.name}),
    ...(params?.email && {cust_email_reg: params.email}),
  }
  const endPoint = params?.dob && params?.name && params?.gender ? ("/settings/TMLoyaltySystem/register-customer") : "/settings/TMLoyaltySystem/get-customer-info" 
  const url = BASE_URL + endPoint;
  setLoading(true)
  try {
    const res = await axios.post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    if(res?.data){
      setLoading(false);
      if(parseInt(res.data.returnvalue) === 50){
        toast.error("Invalid format data",toastObj);
        return false
      }else if(parseInt(res.data.returnvalue) === 27 && res.data.success === false){
        toast.error("Customer blocked",toastObj);
        return false
      }else if(parseInt(res.data.returnvalue) === 30 && res.data.success === false){
        toast.error(res.data.tran_count_lmt_msg,toastObj);
        sessionStorage.setItem("techloyalty",JSON.stringify({redemp_req_amt:res.data?.redemp_req_amt, tran_count_exhausted:true, redeemable_amt: res.data?.redeemable_amt,
          display_campaign_msg: res.data?.display_campaign_msg, campaign_discount: res.data?.campaign_discount, rdmptn_limit_prcnt: res.data?.rdmptn_limit_prcnt}));
        return false
      }else if(parseInt(res.data.returnvalue) === 16 && res.data.success === false && !(res.data?.pos_cust_phone)){
        toast.error("Customer Not Registered",toastObj);
        return res.data;
      }else if(parseInt(res.data?.returnvalue) === 0 && res.data.success){
        if((parseInt(res.data.utype) === 0 || parseInt(res.data.utype) === 1)){
          toast.success("Customer Register sucessfully",toastObj);
        }else if(parseInt(res.data.utype) === 2){
          toast.error("Customer Already Registered!",toastObj);
        }else if(parseInt(res.data.display_campaign_msg) === 1){
          sessionStorage.setItem("techloyalty",JSON.stringify({redemp_req_amt:res.data.redemp_req_amt, tran_count_exhausted:res.data.tran_count_exhausted, redeemable_amt: res.data?.redeemable_amt,
            display_campaign_msg: res.data.display_campaign_msg, campaign_discount: res.data.campaign_discount, rdmptn_limit_prcnt: res.data.rdmptn_limit_prcnt}));
          toast.success(res.data.loyal_campaign_msg,toastObj);
        }else if(Number(res.data.redeemable_amt) >= 0){
          sessionStorage.setItem("techloyalty",JSON.stringify({redemp_req_amt:res.data.redemp_req_amt, tran_count_exhausted:res.data.tran_count_exhausted, redeemable_amt: res.data?.redeemable_amt,
            display_campaign_msg: res.data.display_campaign_msg, campaign_discount: res.data.campaign_discount, rdmptn_limit_prcnt: res.data.rdmptn_limit_prcnt}));
          toast.success("Customer Info Fetched",toastObj);
        }
        return res.data;
      }
    }
    
  }catch(err){
    setLoading(false);
    if(err?.response?.data?.status === 0){
      toast.error(err?.response?.data?.message);
      return err?.response?.data
    }
    toast.error("Register error");
    console.log("loyalty err",err)
    return err?.response?.data;
  }
}

const getDisableLoyality = () =>{
  const checkCanRedeem = JSON.parse(sessionStorage.getItem("techloyalty"));
  if(checkCanRedeem?.tran_count_exhausted || Number(checkCanRedeem?.redemp_req_amt) > 0 || (checkCanRedeem?.display_campaign_msg === "1" && Number(checkCanRedeem?.campaign_discount) > 0)){
    console.log("checkCanRedeem12",checkCanRedeem?.display_campaign_msg === "1")
    return true
  }else{
    return false
  }
}

//search loyality points 
const getLoyaltyItemsInfo = async(params, setLoading) => {
  setLoading(true);
  const items = params.items && params.items.map((item)=> 
    params?.directSettle ? item?.item?.id : item.food_item_id
  );
  try{
    const url = BASE_URL + "/settings/IndoljItemWiseLoyaltySystem/verify-loyalty-code";
    const formData = {
      type: params.code,
      code: params?.phone,
      itemIds: items
    }
    const res = await axios.post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    const result = res.data;
    if(result){
      setLoading(false);
      if(result.status === 0){
        toast.error(result.message,toastObj)
        return false;
      }else{
        toast.success(result.message,toastObj)
        return result
      }
    }
  }catch(err){
    setLoading(false);
    if(err.response.data.status === 0){
      toast.error(err.response.data.message,toastObj)
      return false
    }
    if(err.response.data.status === "error"){
      toast.error(err.response.data.message,toastObj)
      return false
    }
    toast.error("Please try again",toastObj);
    return false;
  }
}

//search loyality points 
const verifyAndFetchLoyalty = async(params, setLoading, id) => {
  setLoading(true)
  try{
    const url = BASE_URL + "/settings/register-token-customer";
    const formData = {
      type: params.code,
      number: params.phone,
      ...(params.code !== "token" && {order_id: id})
    }
    const res = await axios.post(url,formData,{
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    const result = res.data;
    if(result){
      setLoading(false);
      if(params.code === "phone" && !result?.newCustomer){
        toast.success(result?.message,toastObj)
        return {
          ...result,
          points: result.totalPoints,
        }
      }
      if(params.code === "phone" && result?.newCustomer){
        toast.success(result?.message + `.You will get ${result.totalPoints} points after login`,toastObj)
        return {
          ...result,
          points: 0,
        };
      }
      if(params.code === "phone" && result?.code){
        toast.error(result?.code[0],toastObj)
        return {
          ...result,
          points: null,
        };
      }
      if(params.code === "token" && result?.points >= 0){
        toast.success(result?.message,toastObj)
        return {
          ...result,
          points: result.points,
        }
      }
      if(params.code === "token" && result?.message){
        toast.error(result?.message,toastObj)
        return {
          ...result,
          points: null,
        };
      }
    }
  }catch(err){
    setLoading(false)
    toast.error("Please try again",toastObj)
  }
}

//search loyality points 
const syncLoyaltyAndSendOTP = async(params, setLoading) => {
  setLoading(true)
  try{
    const url = BASE_URL + "/settings/TMLoyaltySystem/send-otp";
    const formData = {
      customer_no: params.phone,
      branch_code: params.code
    }
    const res = await axios.post(url,formData,{
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    const result = res.data;
    if(result){
      setLoading(false);
      if(result.returnvalue === 24 || result.returnvalue === 26){
        toast.error(result.msg,toastObj);
        return result;
      }else{
        toast.success(result.msg,toastObj);
        return result
      }
    }
  }catch(err){
    setLoading(false)
    toast.error("Please try again",toastObj);
    return err.response.data
  }
}

//search loyality points 
const fetchVerifyOTP = async(params, setLoading) => {
  setLoading(true)
  try{
    const url = BASE_URL + "/settings/TMLoyaltySystem/verify-otp";
    const formData = {
      customer_no: params.phone,
      branch_code: params.code,
      otp_code: params.otp_code
    }
    const res = await axios.post(url,formData,{
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    const result = res.data;
    if(result){
      setLoading(false);
      if(result.returnvalue === 20 || result.returnvalue === 22 || result.returnvalue === 23){
        toast.error(result.msg,toastObj);
        return result;
      }else{
        toast.success(result.msg,toastObj);
        return result
      }
    }
  }catch(err){
    setLoading(false)
    toast.error("Please try again",toastObj);
    return err.response.data
  }
}

//debounce
function debouncePromise(func, delay) {
  let timeoutId;
  return function (...args) {
    return new Promise((resolve) => {
      // Clear the previous timeout
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const result = func.apply(this, args);
        resolve(result);
      }, delay);
    });
  };
}

export const getApiUrl = (endpoint, authUserInfo, generalSettings) => {
  if(authUserInfo?.details){
    // Check audioInstance, if offline mode is enabled
    const isOfflineEnabled = parseInt(authUserInfo.details?.offline_enable) === 1;
    if (isOfflineEnabled) {
      if(authUserInfo.details?.offline_url){
        return `${authUserInfo.details.offline_url}/offline_pos/api` + endpoint;
      }

      if(generalSettings?.offline_ip){
        return `${generalSettings?.offline_ip}/offline_pos/api` + endpoint;
      }

      return `http://localhost:8081/offline_pos/api` + endpoint;
      
    } else {
      return BASE_URL + endpoint;
    }
  }
}

// order api for fresh data
export const fetchOrderData = async (data, setDataPaginating = null) => {
  const url = BASE_URL + "/settings/get-settle-order/" + data.id;
  setDataPaginating && setDataPaginating(true)
  try {
    const res = await axios.get(url, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    if (res.data) {
      setDataPaginating && setDataPaginating(false);
      return res.data[0];
    }
  } catch (error) {
    setDataPaginating && setDataPaginating(false);
    if (error?.response?.data && error.response.data?.status == 1) {
      toast.error(error.response?.data?.message, toastObj);
      return false;
    }
    toast.error("Please try again", toastObj);
    return false;
  }
}

// getItemRate
export const getItemRate = async (supplier_id, branch_id, item_id) => {
  const url = BASE_URL + "/settings/purchaseorder-item-rate";
  const formData = {
    branch_id: branch_id,
    item_id: item_id,
    supplier_id: supplier_id,
  }
  try {
    const res = await axios.post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    const rate = res.data;
    if(rate){
      return res.data
    }
  } catch (err) {
    console.log("abcd6",err.response)
  }
};

// install check internet
const checkInstallOffline = async () => {
  const url = BASE_URL + "/check-net";
    try{
      let result = await axios.get(url,{
        timeout: 3000,
      });
      if(result.data){
        return false
      }
    }catch(err){
        return true
    } 
}    

//check permission
const checkPermission = (authUserPermissions, permission) => {
  if (authUserPermissions !== false)
    if (authUserPermissions.includes(permission)) {
      return true;
    } else {
      return false;
    }
};

//show price each 1 item qty no property 
const showPriceOfEachOrderItem = (thisItem, taxType, branchTax) => {
  let price = 0;
  let tempPropertyPrice = 0;
  if (thisItem.properties !== null && thisItem.properties !== "") {
    let propertyItems = JSON.parse(thisItem.properties);
    propertyItems.forEach((propertyItem) => {
      let temp = propertyItem.quantity * propertyItem.price_per_qty;
      tempPropertyPrice = tempPropertyPrice + temp;
    });
  }
  price = thisItem.price - tempPropertyPrice;
  if (taxType === "inclusive") {
    let finalPrice = price / (1 + branchTax / 100);
    return formatPrice(finalPrice);
  }else{
    return formatPrice(price);
  }
};

//currency format price
const formatPrice = (price) => {
  let localCurrency = JSON.parse(localStorage.getItem("currency"));
  if (localCurrency !== null) {
    return (localCurrency.rate * price).toFixed(2);
  } else {
    return 0;
  }
};

const currencySymbolLeft = () => {
  let localCurrency = JSON.parse(localStorage.getItem("currency"));
  if (localCurrency !== null) {
    if (localCurrency.alignment === "left") {
      return localCurrency.symbol;
    } else {
      return "";
    }
  } else {
    return "";
  }
};
const currencySymbolRight = () => {
  let localCurrency = JSON.parse(localStorage.getItem("currency"));
  if (localCurrency !== null) {
    if (localCurrency.alignment === "right") {
      return localCurrency.symbol;
    } else {
      return "";
    }
  } else {
    return "";
  }
};

// function formatNumber(value) {
//   return Number(value).toLocaleString();
// }

export const checkBetweenTime = (start, end) => {
  const format = "HH:mm";

  const startTime = moment(start, format);
  const endTime = moment(end, format);
  const currentTime = moment(new Date());
  // If end time is before start time, it means it crosses midnight
  if (endTime.isBefore(startTime)) {
    return (
      currentTime.isSameOrAfter(startTime) ||
      currentTime.isBefore(endTime)
    );
  }

  return currentTime.isBetween(startTime, endTime);
  
};

export const getMinDateByTime = () => {
  if (checkBetweenTime("19:00", "05:00")) {
    return moment().subtract(1, "days").toDate();
  }
  return false;
};

export const getTimeDifferenceString = (start, end) => {
  if (!start || !end) return "";
  const duration = moment.duration(moment(end).diff(moment(start)));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  const pad = (num) => num.toString().padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  } else {
    return `${pad(minutes)}:${pad(seconds)}`;
  }
};

export const getCancelStatusString = (start, end) => {
  if (!start || !end) return "";
  const diffMinutes = moment(end).diff(moment(start), 'minutes');
  
  if (diffMinutes < 30) {
    return "Acceptable";
  } else if (diffMinutes < 60) {
    return "Delayed Cancel";
  } else {
    return "Suspicious Cancel";
  }
};


const formatNumber = (value) => {
  if (!value && value !== 0) return "";
  const str = String(value);
  const [intPart, decPart] = str.split(".");
  // .toLocaleString()
  const formattedInt = (intPart || "0").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (str.endsWith(".")) return `${formattedInt}.`;
  if (decPart !== undefined) return `${formattedInt}.${decPart}`;
  return formattedInt;
};

export const changeNumberFormat = (num) =>{
  return num.replace(/,/g, "")
}


//general settings
const getSystemSettings = (settingsArray, checkType) => {
  let tempItem = settingsArray !== null &&
    settingsArray[checkType];
    // settingsArray.find((item) => {
    //   return item.name === checkType;
    // });
  if (tempItem) {
    return tempItem;
  } else {
    return null;
  }
};

// cal vat percent on print
const vatPercent = (total, vat)=>{
  if(parseFloat(vat) > 0){
    return ((parseFloat(vat)/parseFloat(total)) * 100).toFixed(0)
  }else{
    return 0;
  }
}

const initializeSystemSettings = (generalSettings) => {
  return (
    {
      footerText: getSystemSettings(generalSettings, "type_footer"),
      printFooter: getSystemSettings(generalSettings, "type_print_footer"),
      loyality_enable: getSystemSettings(generalSettings, "loyality_enable"),
      printHeading: getSystemSettings(generalSettings, "type_print_heading"),
      preSettledBilledHeading: getSystemSettings(
        generalSettings,
        "pre_settled_billed_heading"
      ),
      tax_type_discount: getSystemSettings(generalSettings, "tax_type_discount"),
      service_charges_type: getSystemSettings(generalSettings, "service_charges_type"),
      print_logo: getSystemSettings(generalSettings, "print_logo"),
      submit_print_header: getSystemSettings(generalSettings, "submit_print_header"),
      customer_print_instruction: getSystemSettings(generalSettings, "customer_print_instruction"),
      csv_password: getSystemSettings(generalSettings, "csv_password"),
      is_arabic_enable: getSystemSettings(generalSettings, "is_arabic_enable"),
      print_sold_items: getSystemSettings(generalSettings, "print_sold_items"),
      rider_details: getSystemSettings(generalSettings, "rider_details"),
      print_foc_items: getSystemSettings(generalSettings, "print_foc_items"),
      view_expense: getSystemSettings(generalSettings, "view_expense"),
      fp_tax_type: getSystemSettings(generalSettings, "fp_tax_type"),
      fixed_inclusive_tax: getSystemSettings(generalSettings, "fixed_inclusive_tax"),
      online_order_edit: getSystemSettings(generalSettings, "online_order_edit"),
      tax_type: getSystemSettings(generalSettings, "tax_type"),
      duplicate_kot: getSystemSettings(generalSettings, "duplicate_kot"),
      duplicate_payment_bill: getSystemSettings(generalSettings, "duplicate_payment_bill"),
      customer_number_validation: getSystemSettings(generalSettings, "customer_number_validation"),
      auto_settle_fp: getSystemSettings(generalSettings, "auto_settle_fp"),
      disable_fp_order_ring: getSystemSettings(generalSettings, "disable_fp_order_ring"),
      multi_order_settle: getSystemSettings(generalSettings, "multi_order_settle"),
      payment_type_tax_calculation: getSystemSettings(generalSettings, "payment_type_tax_calculation"),
      delivery_charges_addition: getSystemSettings(generalSettings, "delivery_charges_addition"),
      print_order_type_wise_sales: getSystemSettings(generalSettings, "print_order_type_wise_sales"),
      print_payment_wise_sales: getSystemSettings(generalSettings, "print_payment_wise_sales"),
      print_party_wise_sales: getSystemSettings(generalSettings, "print_party_wise_sales"),
      pi_discount: getSystemSettings(generalSettings, "pi_discount"),
      pi_tax: getSystemSettings(generalSettings, "pi_tax"),
      pi_back_date: getSystemSettings(generalSettings, "pi_back_date"),
      auto_creation: getSystemSettings(generalSettings, "auto_creation"),
      stock_entry_receiving: getSystemSettings(generalSettings, "stock_entry_receiving"),
      print_orderParty: getSystemSettings(generalSettings, "print_orderParty"),
      print_heading: getSystemSettings(generalSettings, "print_heading"),
      print_bill_footer: getSystemSettings(generalSettings, "print_bill_footer"),
      kot_header: getSystemSettings(generalSettings, "kot_header"),
      print_branchPhone: getSystemSettings(generalSettings, "print_branchPhone"),
      print_branchAddress: getSystemSettings(generalSettings, "print_branchAddress"),
      print_siteName: getSystemSettings(generalSettings, "print_siteName"),
      print_branchName: getSystemSettings(generalSettings, "print_branchName"),
      print_payment_type: getSystemSettings(generalSettings, "print_paymentType"),
      view_cash_card: getSystemSettings(generalSettings, "view_cash_card"),
      siteName: getSystemSettings(generalSettings, "siteName"),
      address: getSystemSettings(generalSettings, "address"),
      // order_time: getSystemSettings(generalSettings, "order_time")
      dm_customer_validation: getSystemSettings(generalSettings, "dm_customer_validation"),
      fgs_enable: getSystemSettings(generalSettings, "fgs_enable"),
      allow_access_quantity: getSystemSettings(generalSettings, "allow_access_quantity"),
      day_end_stock: getSystemSettings(generalSettings, "day_end_stock"),
      zreport_pos_activity: getSystemSettings(generalSettings, "zreport_pos_activity"),
      zreport_avg_sale: getSystemSettings(generalSettings, "zreport_avg_sale"),
      enable_zReport: getSystemSettings(generalSettings, "enable_zReport"),
      dayend_zreport: getSystemSettings(generalSettings, "dayend_zreport"),
      enable_product_mix: getSystemSettings(generalSettings, "enable_product_mix"),
      enable_pi_zreport: getSystemSettings(generalSettings, "enable_pi_zreport"),
      ideal_food_cost: getSystemSettings(generalSettings, "ideal_food_cost"),
      customer_validation: JSON.parse(getSystemSettings(generalSettings, "customer_validation")),
      online_rider_selection: getSystemSettings(generalSettings, "online_rider_selection"),
      is_feedback: getSystemSettings(generalSettings, "is_feedback"),
      enable_dinein_settle: getSystemSettings(generalSettings, "enable_dinein_settle"),
      pos_ui_screen: getSystemSettings(generalSettings, "pos_ui_screen"),
      party_commission: getSystemSettings(generalSettings, "party_commission"),
      allow_negative_stock: getSystemSettings(generalSettings, "allow_negative_stock"),
      day_end_physical_stock_qty: getSystemSettings(generalSettings, "day_end_physical_stock_qty"),
      enable_online_order_cancellation: getSystemSettings(generalSettings, "enable_online_order_cancellation"),
      has_multi_login: getSystemSettings(generalSettings, "has_multi_login"),
      user_wise_integration: getSystemSettings(generalSettings, "user_wise_integration"),
      rider_integration: getSystemSettings(generalSettings, "rider_integration"),
      day_end_cash: getSystemSettings(generalSettings, "day_end_cash"),
      day_end_stock_mandatory: getSystemSettings(generalSettings, "day_end_stock_mandatory"),
      denomination_confirmation: getSystemSettings(generalSettings, "denomination_confirmation"),
      print_callcenter_kot: getSystemSettings(
        generalSettings,
        "print_callcenter_kot"
      ),
      phnNo: getSystemSettings(generalSettings, "phnNo"),
      online_order_status: getSystemSettings(generalSettings, "online_order_status"),
      waiter_order_type: getSystemSettings(generalSettings, "waiter_order_type") ? JSON.parse(getSystemSettings(generalSettings, "waiter_order_type")) : null,
      physical_stock: getSystemSettings(generalSettings, "physical_stock") === "1" ? 1 : 0,
      token_text: getSystemSettings(generalSettings, "token_text"),
      duplicate_print_text: getSystemSettings(generalSettings, "duplicate_print_text"),
      firebase_collection: getSystemSettings(generalSettings, "firebase_collection"),
      vat: getSystemSettings(generalSettings, "type_vat"),
      cgst: getSystemSettings(generalSettings, "cgst"),
      sgst: getSystemSettings(generalSettings, "sgst"),
      tax: getSystemSettings(generalSettings, "tax"),
      sDiscount: getSystemSettings(generalSettings, "sDiscount"),
      recipe_enable: getSystemSettings(generalSettings, "recipe_enable"),
      fg_purchase_stock_qty: getSystemSettings(generalSettings, "fg_purchase_stock_qty"),
      day_open: getSystemSettings(generalSettings, "day_open"),
      order_no: getSystemSettings(generalSettings, "order_no"),
      issue_qty_lock: getSystemSettings(generalSettings, "issue_qty_lock"),
      issuance_amount_view: getSystemSettings(generalSettings, "issuance_amount_view"),
      offers_lock_status: getSystemSettings(generalSettings, "offers_lock_status"),
      foodPanda_integration: getSystemSettings(generalSettings, "foodPanda_integration"),
      call_center_enable: getSystemSettings(generalSettings, "call_center_enable"),
      date_wise: getSystemSettings(generalSettings, "date_wise"),
      notifier_and_manage: getSystemSettings(generalSettings, "notifier_and_manage"),
      digital_menu_qr: getSystemSettings(generalSettings, "digital_menu_qr"),
      min_rate_popular: getSystemSettings(generalSettings, "min_rate_popular"),
      self_order_check: getSystemSettings(generalSettings, "self_order_check"),
      image: null,
      favicon: null,
      timezone: getSystemSettings(generalSettings, "timezone"),
      print_setting: 0,
      zreport_setting: 0,
      print_pos_setting: getSystemSettings(generalSettings, "print_pos_setting"),
      delivery_charges: getSystemSettings(generalSettings, "delivery_charges"),
      delivery_charges_lock: getSystemSettings(
        generalSettings,
        "delivery_charges_lock"
      ),
      till_user: getSystemSettings(generalSettings, "till_user"),
      view_userOrder: getSystemSettings(generalSettings, "view_userOrder"),
      pos_discount: getSystemSettings(generalSettings, "pos_discount"),
      print_kitchen_bill: getSystemSettings(generalSettings, "print_kitchen_bill") === "1" ? 1 : 0,
      play_sound: getSystemSettings(generalSettings, "play_sound") === "1" ? 1 : 0,
      table_waiter: getSystemSettings(generalSettings, "table_waiter") === "1" ? 1 : 0,
      order_round_off: getSystemSettings(generalSettings, "order_round_off"),
      stock_round_off: getSystemSettings(generalSettings, "stock_round_off"),
      auto_replenish_document: getSystemSettings(generalSettings, "auto_replenish_document"),
      customer_screen_enable: getSystemSettings(generalSettings, "customer_screen_enable") === "1" ? 1 : 0,
      direct_ip_print: getSystemSettings(generalSettings, "direct_ip_print") === "1" ? 1 : 0,
      open_qty_box: getSystemSettings(generalSettings, "open_qty_box") === "1" ? 1 : 0,
      foods_in_setting: getSystemSettings(generalSettings, "foods_in_setting") === "1" ? 1 : 0,
      enable_waiter_selection: getSystemSettings(generalSettings, "enable_waiter_selection") === "1" ? 1 : 0,
      online_order_addon: getSystemSettings(generalSettings, "online_order_addon"),
      change_odt_edit: getSystemSettings(generalSettings, "change_odt_edit"),
      item_wise_discount: getSystemSettings(generalSettings, "item_wise_discount"),
      zreport_addon: getSystemSettings(generalSettings, "zreport_addon"),
      // onlyVat:
      //   getSystemSettings(generalSettings, "vat_system") === "igst"
      //     ? true
      //     : false,
      onlyVat:
        getSystemSettings(generalSettings, "vat_system") === "igst"
          ? 1
          : getSystemSettings(generalSettings, "vat_system") === "cgst"
            ? 2
            : 3,
    }
  )

}

export const customError = (err)=>{
  if(err?.response?.data?.message[0] || err.response?.data?.status === 0){
    ToastError({ title: err.response.data?.status === 0 ? err.response.data.message : err?.response?.data?.message[0] });
    return true
  }
  return false
}

const normalizePkMobile = (raw) => {
  let digits = String(raw ?? "").replace(/\D/g, "");

  // +92XXXXXXXXXX -> 0XXXXXXXXXX
  if (digits.startsWith("92")) digits = `0${digits.slice(2)}`;

  // Always enforce "03" prefix when there's any input intent
  if (digits.length === 0) return "";
  if (digits === "0") return "03";
  if (digits === "03") return "03";
  if (!digits.startsWith("03")) {
    // user typed without leading 0 (e.g. "3XXXXXXXXX")
    if (digits.startsWith("3")) digits = `0${digits}`;
    // any other start -> force prefix and keep rest (best-effort)
    if (!digits.startsWith("03")) digits = `03${digits.replace(/^0+/, "")}`;
  }

  return digits.slice(0, 11);
};

const countryRules = {
  // Pakistan
  "03": 11,
  "021": 11,
  "051": 11,
  "042": 11,
  "92": 12,
  "+92": 13,

  // International
  "+1": 12,          // USA
  "+44": 13,         // UK
  "+971": [12, 13],  // UAE
  "+966": [12, 13],  // Saudi
  "+60": [11, 12],   // Malaysia
  "+65": 11,         // Singapore
};

const isValidPkMobile = (v) => {
  const val = String(v ?? "").replace(/[\s-]+/g, "");

  if(val === "00000000000"){
    return true
  }

  for (const prefix in countryRules) {
    if (val.startsWith(prefix)) {
      const rule = countryRules[prefix];

      const isValid = Array.isArray(rule)
        ? rule.includes(val.length)
        : val.length === rule;
      if(isValid){
        return true;
      }
      ToastError({ title: `Please enter valid phone no (${prefix}XXXXXXXXX)`, toastId: "invalid-phone" });
      return false;
    }
  }

  ToastError({ title: "Please enter valid phone no", toastId: "invalid-phone" });
  return false;
};

export const deleteLogoutCookie = () =>{
  if (cookies.get("_user") !== undefined) {
    cookies.remove("_user", { path: "/" });
  }
  if (cookies.get("sbb") !== undefined) {
    cookies.remove("sbb", { path: "/" });
  }
  if (cookies.get("frr") !== undefined) {
    cookies.remove("frr", { path: "/" });
  }
  if (cookies.get("xss") !== undefined) {
    cookies.remove("xss", { path: "/" });
  }
  if (cookies.get("_fb-user") !== undefined) {
    cookies.remove("_fb-user", { path: "/" });
  }
  if (cookies.get("fb") !== undefined) {
    cookies.remove("fb", { path: "/" });
  }
}

//Delete cookie of authentication
const deleteCookie = async() => {
  const url = BASE_URL + `/auth/logout`;
  try {
    const res = await axios.get(url, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
      if(res.data){
        deleteLogoutCookie()
        window.location.reload(true);
      }
  } catch(error){
    deleteLogoutCookie()
    window.location.reload(true);
  }  
};

//restaurant dashboard menu links
const restaurantMenuLink = (
  img,
  imgAlt,
  icon,
  infoTextColor,
  info,
  title,
  redirectTo
) => {
  return (
    <div className="col-md-6 col-lg-4 t-mb-15">
      <NavLink to={redirectTo} className="t-link product-card t-bg-white w-100">
        <div className="product-card__head w-100 text-center">
          <img src={img} alt={imgAlt} className="img-fluid" />
        </div>
        <div className="product-card__body w-100">
          <div className="product-card__add">
            <span className="product-card__add-icon">
              <span className="las la-plus"></span>
            </span>
          </div>
          <span
            className={`product-card__sub-title ${infoTextColor} text-uppercase`}
          >
            <span className={icon}></span> {info}
          </span>
          <span className="product-card__title text-capitalize">{title}</span>
        </div>
      </NavLink>
    </div>
  );
};

//generate hashmac
async function generateSHA256(hashKey, hmac = "KEY@#MERCHANT@$", branch_id = null) {
  const key = branch_id ? (hashKey + '|' + hmac + '|' + branch_id) : (hashKey + hmac);

  const encoder = new TextEncoder();
  const data = encoder.encode(key);

  const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashedKey = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");

  return hashedKey;
}

//encrypt hash
async function encryptAES128(id, secretKey="ORDER@#FEEDBACK@") {

  const encoder = new TextEncoder();
  const keyBytes = encoder.encode(secretKey);
  const ivBytes = encoder.encode(secretKey); // static IV for demo

  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["encrypt"]
  );

  const data = encoder.encode(String(id));

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv: ivBytes },
    key,
    data
  );

  // Convert to Hex
  const byteArray = new Uint8Array(encryptedBuffer);
  const hexString = Array.from(byteArray)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

  return hexString;
}

// get merchant menu
const getMerchantMenu = async (token, secretKey, b_id=1, table_name=null, order_type=null) => {
  try {
    const encryptedToken = await encryptAES128(token, secretKey);
    const url = BASE_URL + "/settings/get-merchant-menu";
    const params = { branch_id: b_id, token: encryptedToken };
    if (table_name) {
      params.table_name = table_name;
    }
    if (order_type) {
      params.order_type = order_type;
    }
    const response = await axios.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching merchant menu:", error);
    if(error.response?.data?.status === 0){
      ToastError({ title: error.response.data?.message, position : "top-right", toastId: "order-placed-error-msg" });
      return null;
    }
    return null;
  }
};


//manage page mobile screen link
const managePageHrefLinkMobile = (redirectTo, menuName) => {
 // if(authUserInfo.permissions !== null && checkPermission(authUserInfo.permissions, menuName)) {
  if (window.location.pathname === redirectTo) {
    return (
      <li
        className={`fk-sm-nav__list  ${
          window.location.href.includes(redirectTo) && "active"
        }`}
      >
        <NavLink
          to={{ pathname: "/refresh", state: redirectTo }}
          exact
          className={`t-link fk-sm-nav__link`}
        >
          {menuName}
        </NavLink>
      </li>
    );
  } else {
    return (
      <li
        className={`fk-sm-nav__list  ${
          window.location.href.includes(redirectTo) && "active"
        }`}
      >
        <NavLink to={redirectTo} exact className={`t-link fk-sm-nav__link`}>
          {menuName}
        </NavLink>
      </li>
    );
  } 
  // }else{
  //   ""

  // }

};

//manage page navlink
const managePageHrefLink = (redirectTo, menuName) => {
  //if(authUserInfo.permissions !== null && checkPermission(authUserInfo.permissions, menuName)) {
  if (window.location.pathname === redirectTo) {
    return (
      <li className="fk-pos-nav__sub-list border-bottom">
        <NavLink
          to={{ pathname: "/refresh", state: redirectTo }}
          exact
          className={`w-100 sm-text t-text-dark btn font-weight-bold text-capitalize rounded-0 text-left ${
            window.location.href.includes(redirectTo) && "active"
          }`}
        >
          - {menuName}
        </NavLink>
      </li>
    );
  } else {
    return (
      <li className="fk-pos-nav__sub-list border-bottom">
        <NavLink
          to={redirectTo}
          exact
          className={`w-100 sm-text t-text-dark btn font-weight-bold text-capitalize rounded-0 text-left ${
            window.location.href.includes(redirectTo) && "active"
          }`}
        >
          - {menuName}
        </NavLink>
      </li>
    );
  }
// }else{
//   ""
// }
};

//pagination
const pagination = (data, customFunction) => {
  return (
    <ReactPaginate
      pageCount={data && data.last_page}
      initialPage={0}
      marginPagesDisplayed={5}
      pageRangeDisplayed={2}
      onPageChange={(page) => {
        customFunction(page.selected + 1);
      }}
      breakLabel={". . ."}
      breakClassName={"px-2"}
      containerClassName={"t-list d-flex"}
      pageClassName={"t-list__item mr-0"}
      previousLabel={<i className="las la-angle-double-left"></i>}
      nextLabel={<i className="las la-angle-double-right"></i>}
      pageLinkClassName={
        "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
      }
      previousClassName={
        "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
      }
      nextClassName={
        "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
      }
      activeClassName={"pagination-active"}
      activeLinkClassName={"text-white"}
    />
  );
};

// pagination loading
const paginationLoading = () => {
  return <Skeleton style={{ height: "40px" }} className="card bg-white" />;
};

// modal loading ff7675
const modalLoading = (count) => {
  return (
    <SkeletonTheme color="#0dd19d" highlightColor="#dfe4ea">
      <p>
        <Skeleton count={count} />
      </p>
    </SkeletonTheme>
  );
};

// manage page table loading
const tableLoading = () => {
  return (
    <SkeletonTheme color="#f1f2f6" highlightColor="#dfe4ea">
      <p>
        <Skeleton style={{ height: `calc(100vh - 222px)` }} />
      </p>
    </SkeletonTheme>
  );
};

// table loading
const pageLoading = () => {
  return (
    <SkeletonTheme color="#f1f2f6" highlightColor="#dfe4ea">
      <p>
        <Skeleton style={{ height: `calc(100vh - 187px)` }} />
      </p>
    </SkeletonTheme>
  );
};

// data count details of tables
const showingData = (data) => {
  return (
    <>
      {/* todo:: translation function call */}
      Showing {data && data.from} - {data && data.to} of {data && data.total}
    </>
  );
};

// searched data count details of table
const searchedShowingData = (data, allData) => {
  return (
    <>
      {/* todo:: translation function call */}
      Showing {data && data.list.length} of {allData && allData.length}
    </>
  );
};

//pagination of order history
const paginationOrderHistory = (data, customFunction) => {
  return (
    <ReactPaginate
      pageCount={data && data.meta.last_page}
      initialPage={0}
      marginPagesDisplayed={5}
      pageRangeDisplayed={2}
      onPageChange={(page) => {
        customFunction(page.selected + 1);
      }}
      breakLabel={". . ."}
      breakClassName={"px-2"}
      containerClassName={"t-list d-flex"}
      pageClassName={"t-list__item mr-0"}
      previousLabel={<i className="las la-angle-double-left"></i>}
      nextLabel={<i className="las la-angle-double-right"></i>}
      pageLinkClassName={
        "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
      }
      previousClassName={
        "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
      }
      nextClassName={
        "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
      }
      activeClassName={"pagination-active"}
      activeLinkClassName={"text-white"}
    />
  );
};

// data count details of tables of order history
const showingDataOrderHistory = (data) => {
  return (
    <>
      {/* todo:: translation function call */}
      Showing {data && data.meta.from} - {data && data.meta.to} of{" "}
      {data && data.meta.total}
    </>
  );
};

// searched data count details of table of order history
const searchedShowingDataOrderHistory = (data, allData) => {
  return (
    <>
      {/* todo:: translation function call */}
      Showing {data && data.list.length} of {allData && allData.data.length}
    </>
  );
};

// get date pattern for save api
const getDate = (date) => {
  let date_for_api =
  new Date(date).getFullYear() +
  "-" +
  (new Date(date).getMonth() + 1) +
  "-" +
  new Date(date).getDate();
  return date_for_api;
}

export const timeToDate = (time) => {
  if (!time) return null;

  const [h, m] = time.split(":").map(Number);

  const date = new Date();
  date.setHours(h, m, 0, 0);

  return date;
};

//get offline status
const getOffline = async(url) => {
  const network = await checkNetworkStatus();
  return !network && localStorage.getItem(url) != null;
};

// get tax integration details
const getTaxIntegrationDetails = (branch, fbrInvoiceNum, srbInvoiceNum, srbUrl = null) => {
  if (!branch) return null;

  if (branch.fbr_integration === 1 && fbrInvoiceNum) {
    return {
      taxTaken: "FBR",
      printText: "Verify this invoice through FBR TaxAsaan MobileApp or SMS at 9966",
      taxImage: "/assets/img/pos-invoice-system.png",
      qrValue: fbrInvoiceNum
    };
  }
  if (branch.cbr_integration === 1 && fbrInvoiceNum) {
    return {
      taxTaken: "AJK-IRD",
      printText: "Verify this invoice through AJK-IRD TaxAsaan MobileApp or SMS at 9966",
      taxImage: "/assets/img/cbr.png",
      qrValue: fbrInvoiceNum
    };
  }
  if (branch.pbr_integration === 1 && fbrInvoiceNum) {
    return {
      taxTaken: "PRA",
      printText: "Verify this invoice through PRA TaxAsaan MobileApp or SMS at 9966",
      taxImage: "/assets/img/PRA.png",
      qrValue: fbrInvoiceNum
    };
  }
  if (branch.kpra_integration === 1 && fbrInvoiceNum) {
    return {
      taxTaken: "KPRA",
      printText: "Verify this invoice through KPRA MobileApp",
      taxImage: "/assets/img/kpra.jpeg",
      qrValue: srbUrl ? srbUrl : fbrInvoiceNum
    };
  }
  if (srbInvoiceNum) {
    return {
      taxTaken: "SRB",
      printText: srbUrl ? "Verify this invoice through eSRB MobileApp or QR Code" : "Verify this invoice through eSRB MobileApp or SMS at 9697",
      taxImage: "/assets/img/srb_pos_image.png",
      qrValue: srbUrl ? srbUrl : srbInvoiceNum
    };
  }
  return null;
}

const validateItemsProperty = (items, property, errorMessage) => {
  if (items && items.length > 0) {
    const isInvalid = items.some(item => {
      const value = item[property];
      return value === 0 || value === "0" || value === "" || value === null || value === undefined;
    });

    if (isInvalid) {
      toast.error(errorMessage || `${property} cannot be zero or empty`, toastObj);
      return false;
    }
  }
  return true;
};

/** Show first selected branch name, then "+N" for remaining */
const BranchMultiValue = (props) => {
  const { index, getValue, data } = props;
  const selected = getValue() || [];
  const selectedCount = selected.length;
  const remaining = selectedCount - 1;

  // Only render once (for the first selected value)
  if (index > 0) return null;

  const firstLabel =
    data && data.name != null
      ? data.name
      : selected[0] && selected[0].name != null
        ? selected[0].name
        : "";

  return (
    <div
      className="d-flex align-items-center"
      style={{
        fontSize: "0.9rem",
        fontWeight: 600,
        lineHeight: 1.2,
        padding: "0 4px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        maxWidth: "100%",
        color: "#212529",
        gap: "4px",
      }}
      title={selected.map((opt) => opt.name).join(", ")}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: remaining > 0 ? "110px" : "160px",
        }}
      >
        {firstLabel}
      </span>
      {remaining > 0 ? (
        <span
          style={{
            flexShrink: 0,
            background: "#e9ecef",
            borderRadius: "10px",
            padding: "1px 6px",
            fontSize: "0.8rem",
            fontWeight: 700,
          }}
        >
          {remaining}+
        </span>
      ) : null}
    </div>
  );
};

const branchSelectStyles = {
  ...customStyle,
  control: (provided) => ({
    ...customStyle.control(provided),
    minHeight: "2rem",
    maxHeight: "2rem",
    overflow: "hidden",
  }),
  valueContainer: (provided) => ({
    ...provided,
    flexWrap: "nowrap",
    overflow: "hidden",
    maxHeight: "2rem",
    padding: "0 0.5rem",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    margin: 0,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: "0.95rem",
    fontWeight: 600,
    padding: 0,
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
};

// html string generator for pdf
const generatePdfHtmlTemplate = (reportHtml, title = "Report") => {
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>${title}</title>
       
        <style>
          body { font-family: sans-serif; }
          .table { border-collapse: collapse; width: 100%; }
          .font-weight-bold { font-weight: 700 !important; }
          .table>tbody {vertical-align: inherit;}
          .table>thead {vertical-align: bottom;}
          .table-bordered, .table-bordered th, .table-bordered td { 
            border: 1px solid #b9bbbe !important; 
          }
          .py-2 { padding-top: 0.5rem !important; padding-bottom: 0.5rem !important; }
          .py-3 { padding-top: 1rem !important; padding-bottom: 1rem !important; }
          .px-3 { padding-right: 1rem !important; padding-left: 1rem !important; }
          .text-left{ text-align: left; }
          .text-center{ text-align: center; }
          .text-white { color: #fff }
          .table-sm th, .table-sm td {
            padding: 0.25rem 0.25rem;
          }
        </style>
      </head>
      <body>${reportHtml}</body>
    </html>
  `;
};
const generateUniqueToken = (branchId) => {
  const currentTime = new Date().getTime();
  return Number(String(currentTime) + String(branchId ?? ""));
};

const getDeviceTokenValue = (branchId) => {
  if (!branchId) return "";
  const storageKey = `digital_menu_token_${branchId}`;
  const existingDataStr = localStorage.getItem(storageKey);
  
  if (existingDataStr) {
    try {
      const parsedData = JSON.parse(existingDataStr);
      return parsedData?.token || "";
    } catch (e) {
      console.warn("Could not parse token from localStorage:", e);
    }
  }
  return "";
};

const getOrCreateDeviceToken = (branchId, forceRegenerate = false) => {
  if (!branchId) return null;
  
  const storageKey = `digital_menu_token_${branchId}`;
  const existingDataStr = localStorage.getItem(storageKey);
  const currentTime = Date.now();
  
  if (!forceRegenerate && existingDataStr) {
    try {
      const { token, timestamp } = JSON.parse(existingDataStr);
      const timeDiff = currentTime - timestamp;
      const expiryTime = 3.5 * 60 * 60 * 1000;
      // Ensure token is less than 3 hours old AND not in the future (timeDiff >= 0)
      if (timeDiff >= 0 && timeDiff < expiryTime) {
        return token;
      }
    } catch (e) {
      // Ignore parse errors, we will overwrite the corrupted key below
    }
  }

  // Generate new token and overwrite local storage
  const newToken = generateUniqueToken(branchId);
  try {
    localStorage.setItem(storageKey, JSON.stringify({ token: newToken, timestamp: currentTime }));
  } catch (e) {
    console.warn("Could not save token to localStorage:", e);
  }
  
  return newToken;
};

//export here
export {
  getDeviceTokenValue,
  getOrCreateDeviceToken,
  generateUniqueToken,
  checkInstallOffline,
  generatePdfHtmlTemplate,
  // common & necessary
  _t,
  consolee,
  getOffline,
  getCookie,
  deleteCookie,
  checkPermission,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
  getSystemSettings,
  initializeSystemSettings,
  normalizePkMobile,
  isValidPkMobile,
  // common & necessary
  handleCardTransaction,

  //navLink
  restaurantMenuLink,
  managePageHrefLinkMobile,
  managePageHrefLink,
  //navLink

  //loading
  pageLoading,
  modalLoading,
  tableLoading,
  paginationLoading,
  //loading

  //api load
  setApiTime,
  getApiTime,
  isTimeExpired,

  //pagination and datacounting
  pagination,
  paginationOrderHistory,
  showingData,
  searchedShowingData,
  showingDataOrderHistory,
  searchedShowingDataOrderHistory,
  //pagination and datacounting
  vatPercent,
  //sync order
  offlineOrderSync,
  // print price
  showPriceOfEachOrderItem,
  getVoucherUsage,
  getReseredTime,
  handleGetOrders,
  //loyalty points api
  getCustomerRegInfo,
  getLoyaltyItemsInfo,
  verifyAndFetchLoyalty,
  fetchVerifyOTP,
  syncLoyaltyAndSendOTP,
  getDisableLoyality,
  
  // firebase authentication
  getFirebaseToken,
  generateSHA256,
  encryptAES128,
  debouncePromise,
  getFirebaseCookie,
  //select style
  customStyle,
  formatNumber,
  //get loyality point
  maxLoyaltyPoint,
  getLoyaltyPoint,  //net api
  checkNetworkStatus,
  //get api date
  getMerchantMenu,
  getDate,
  getTaxIntegrationDetails,
  validateItemsProperty,
  BranchMultiValue,
  branchSelectStyles,
};
/*
----------------------------------------------
                      Ends
----------------------------------------------
*/
